import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radio", "regionField"]

  toggle() {
    const isShared = this.radioTargets.find(r => r.checked)?.value === "true"
    if (this.hasRegionFieldTarget) {
      this.regionFieldTarget.classList.toggle("hidden", isShared)
      if (isShared) {
        const select = this.regionFieldTarget.querySelector("select, input[name$='[region_id]']")
        if (select) select.value = ""
      }
    }
  }
}
